import React from "react";
import { Box, SxProps, Theme, Typography } from "@mui/material";
import CommonTypo from "../../components/CommonTypo";
import { IUserTypeState } from "../../interfaces/outcomeModal";
import NewButton from "../../components/NewButton";
import clsx from "clsx";
import ArrowDownNew, { ArrowDownNewBlack } from "../../assets/images/icon/ArrowDownGreenNew";
import Integrations from "../setting/integrations";
import { TOOLTIP_PLACEMENT } from "./TableSpotlight";

const modalStyles = {
    // marginTop: "0px",
    width: "302px",
    height: "299px",
    borderRadius: "12px",
    padding: "24px",
    gap: "8px",
    display: "flex",
    flexDirection: "column"
}

const TextBoxWithBorder = ({ text, size = 16, lineHeight = 26, color = "var(--color-text-primary)" }) => {
    return <Box zIndex={1} display={"flex"} alignItems={"center"} alignSelf={"stretch"} padding={"16px"} border={"1px solid var(--color-border)"} borderRadius={"12px"}>
        <CommonTypo
            size={size}
            lineHeight={lineHeight}
            color={color}
        >
            {text}
        </CommonTypo>
    </Box>
}
const ForastBearNormal = () => {
    return <Box display={"flex"} flexDirection={"column"} zIndex={1}>
        <CommonTypo size={16} lineHeight={26} color="var(--color-text-primary)">Frost, The Bear</CommonTypo>
        <CommonTypo size={12} lineHeight={20} color="var(--color-text-secondary)">Your cutest coach</CommonTypo>
    </Box>
}
const ForastBearWithImage = () => {
    return <Box
        gap="24px"
        display={"flex"}
        alignItems={"center"}
    >
        <Box
            gap="16px"
            display={"flex"}
            alignItems={"center"}
        >
            <Box width="48px"
                height="48px"
                border="1px solid var(--color-border)"
                borderRadius={"100%"}
                overflow={"hidden"}
                sx={{
                    width: "48px",
                    height: "48px",
                    backgroundImage: "url('/froasttutorial.png')",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "600%",
                    backgroundPosition: "40% 22%", // Adjust here for visible portion
                    overflow: "hidden",
                }}
            >
                {/* <img src="/froasttutorial.png" style={{
                    objectFit: "cover",
                    objectPosition: "50% 20%",
                    width: "250%",
                    height: "250%",
                    overflow: "hidden"
                }} alt="froasttutorial" /> */}
            </Box>
            <ForastBearNormal />
        </Box>

    </Box>
}

export const TUTORIAL_STEPS = [
    {
        step: 1,
        modal: true,
        brearVisible: false,
        content: (IUserTypeState: IUserTypeState) => {
            return <>
                <ForastBearNormal />
                <TextBoxWithBorder text={`Hello, ${IUserTypeState?.userDetails?.first_name}!`} size={12} lineHeight={20} />
            </>
        },
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 2,
        modal: true,
        brearVisible: false,
        content: (IUserTypeState: IUserTypeState) => {
            return <>
                <ForastBearNormal />
                <TextBoxWithBorder text={`Hello, ${IUserTypeState?.userDetails?.first_name}!`} size={12} lineHeight={20} />
                <TextBoxWithBorder text={`Are you ready to break the ice with your first tracking?`} size={12} lineHeight={20} />
            </>
        },
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 3,
        modal: true,
        brearVisible: false,
        content: (IUserTypeState: IUserTypeState, onButtonClick) => {
            return <>
                <ForastBearNormal />
                <TextBoxWithBorder text={`Hello, ${IUserTypeState?.userDetails?.first_name}!`} size={12} lineHeight={20} />
                <TextBoxWithBorder text={`Are you ready to break the ice with your first tracking?`} size={12} lineHeight={20} />
                <NewButton buttonText="Start Now" onClick={onButtonClick} extraSx={{
                    minWidth: "114px",
                    padding: "16px",
                    height: "40px",
                    borderRadius: "20px",
                    zIndex: 1
                }}
                    boxSx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    typographySx={{
                        fontSize: "16px !important",
                        color: "var(--color-text-primary)",
                        fontWeight: `600 !important`
                    }}
                    padding="16px"
                    borderRadius="20px" />
            </>
        },
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 4,
        modal: false,
        brearVisible: false,
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick) => {
            const { journeyCategoryList = [] } = IUserTypeState
            let planName = "Stress"
            if (journeyCategoryList && journeyCategoryList[0] && journeyCategoryList[0].name) {
                planName = journeyCategoryList[0].name
            }
            return <>
                <Box width="auto"
                    height="auto"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>This is a <strong>metric category,</strong> which contains all related metrics. The first category is your selected plan for {planName}.</>} />
                    </Box>
                    <NewButton buttonText="Next" onClick={onButtonClick} extraSx={{
                        minWidth: "114px",
                        padding: "16px",
                        height: "40px",
                        borderRadius: "20px",
                        zIndex: 1
                    }}
                        boxSx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        typographySx={{
                            fontSize: "16px !important",
                            color: "var(--color-text-primary)",
                            fontWeight: `600 !important`
                        }}
                        padding="16px"
                        borderRadius="20px" />
                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            console.log("IUserTypeState", IUserTypeState);
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList[0]) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    return `.default-col-1-row-${(foundGeneral + 1)}-subrow-${IUserTypeState.journeyCategoryList[0]?.alls?.length}`
                }
            }
            return ".default-col-1-subrow-1"

        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            return ".default-col-1-row-1"
        },
        tooltipPlacement: "right-end" as TOOLTIP_PLACEMENT,
        tooltip: "Text",
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 5,
        modal: false,
        brearVisible: false,
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            You can also create your <strong>own custom categories.</strong> I’ll explain when you got your first few days under your belt.
                        </>} />
                    </Box>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={"8px"}
                        alignSelf={"stretch"}
                        sx={{
                            '& > button': {
                                flex: 1
                            }
                        }}
                    >
                        <NewButton
                            buttonText="Back"
                            onClick={onBackButtonClick}
                            extraSx={{
                                padding: "16px",
                                height: "40px",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%",
                                background: "var(--color-border)",
                                "&:hover": {
                                    background: "var(--color-border)",
                                }
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `600 !important`
                            }}
                            padding="16px"
                            borderRadius="20px" />
                        <NewButton
                            buttonText="Next"
                            onClick={onButtonClick}
                            extraSx={{
                                padding: "16px",
                                height: "40px",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%"
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `600 !important`
                            }}
                            padding="16px"
                            borderRadius="20px" />
                    </Box>

                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            return ".default-col-1-row-2"

        },
        customInTable: (classes) => {
            const boxRetrn = (icon, title, gap = 4, typeShow = false) => {
                return <tr >
                    <td style={{
                        padding: "16px",
                        background: "#FFF",
                        borderBottom: "1px solid var(--color-border)"
                    }}><Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        gap={"16px"}
                    >
                            <Box display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                                gap={gap + "px"}>
                                {icon}
                                {title}
                            </Box>
                            {typeShow && (
                                <Box display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"space-between"}
                                    gap={"16px"}>
                                    <Box width="24px"
                                        height="24px"
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"center"}>
                                        <ArrowDownNewBlack />
                                    </Box>
                                </Box>
                            )}

                        </Box>
                    </td>
                </tr>
            }
            return <Box
                sx={{
                    // background: "red",
                    width: "100%",
                    height: "100%"
                }}
                borderRadius="12px"
                padding="16px"
                display={"flex"}
                flexDirection={"column"}
            >
                <table width="100%" cellPadding={0} cellSpacing={0}>

                    {boxRetrn(<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.3719 11.2153C23.2512 11.0039 23.0895 10.8188 22.8964 10.6707C22.7032 10.5226 22.4824 10.4145 22.2469 10.3528C21.684 10.2069 21.1053 10.1303 20.5238 10.125C20.735 8.80839 20.6388 7.46074 20.2425 6.18752C20.0998 5.74034 19.7956 5.36233 19.3894 5.12715C18.9832 4.89196 18.5039 4.81645 18.045 4.91533C17.1802 5.10615 16.3516 5.43438 15.5907 5.88752C14.9788 4.76383 14.139 3.78033 13.125 3.00002C12.8 2.7576 12.4055 2.62665 12 2.62665C11.5946 2.62665 11.2 2.7576 10.875 3.00002C9.86106 3.78033 9.02125 4.76383 8.4094 5.88752C7.64941 5.43433 6.82174 5.10579 5.95784 4.91439C5.49884 4.81556 5.01948 4.8912 4.61322 5.12657C4.20696 5.36194 3.90291 5.74017 3.76034 6.18752C3.36409 7.46074 3.26783 8.80839 3.47909 10.125C2.89663 10.1301 2.31699 10.2066 1.75315 10.3528C1.51767 10.4145 1.29687 10.5226 1.1037 10.6707C0.910516 10.8188 0.748843 11.0039 0.628151 11.2153C0.503344 11.4302 0.422497 11.6678 0.390308 11.9142C0.35812 12.1606 0.375232 12.4109 0.440651 12.6506C0.773463 13.8844 1.79065 16.2281 4.86003 18.0619C7.89003 19.875 10.5713 19.875 12.0075 19.875C13.4438 19.875 16.11 19.875 19.1391 18.0619C22.2085 16.2281 23.2256 13.8844 23.5585 12.6506C23.624 12.411 23.6413 12.1607 23.6093 11.9143C23.5772 11.6679 23.4965 11.4303 23.3719 11.2153ZM6.01503 16.1297C3.92534 14.881 3.07596 13.3988 2.73378 12.4406C3.1845 12.3687 3.64253 12.3542 4.0969 12.3975C4.32315 12.9692 4.59105 13.5235 4.89846 14.056C5.41363 14.9464 6.0299 15.7744 6.73502 16.5235C6.4969 16.4063 6.2569 16.275 6.01503 16.1297ZM7.40628 13.8066C7.2094 13.5253 7.02003 13.2441 6.84378 12.9356C5.37846 10.3781 5.51628 8.33814 5.81253 7.19627C6.42725 7.37672 7.01175 7.64748 7.5469 7.9997C7.2609 9.03274 7.11893 10.1003 7.12503 11.1722C7.12094 12.058 7.21527 12.9416 7.40628 13.8066ZM12 17.3691C11.0888 16.6125 9.37502 14.7178 9.37502 11.1694C9.37502 7.66127 11.0625 5.76002 12 4.97439C12.9375 5.76002 14.625 7.66127 14.625 11.1694C14.625 14.7188 12.9113 16.6153 12 17.3719V17.3691ZM16.5938 13.8066C16.7848 12.9416 16.8791 12.058 16.875 11.1722C16.8811 10.1003 16.7392 9.03274 16.4531 7.9997C16.9883 7.64725 17.5728 7.37617 18.1875 7.19533C18.481 8.33814 18.6188 10.3828 17.1507 12.9356C16.9782 13.2403 16.7888 13.53 16.5938 13.8066ZM17.9869 16.1297C17.7469 16.2731 17.5097 16.4025 17.2763 16.5197C17.9785 15.7714 18.5923 14.9447 19.1053 14.056C19.4127 13.5235 19.6807 12.9692 19.9069 12.3975C20.3613 12.3542 20.8193 12.3687 21.27 12.4406C20.9241 13.3988 20.0747 14.881 17.985 16.1297H17.9869Z" fill="#292B2A" />
                    </svg>
                        , <CommonTypo size={18} fontWeight={600} color="var(--color-text-primary)">Sleep</CommonTypo>, 8, true)}

                </table>
            </Box>
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            return ".default-col-1-row-1-subrow-5"
        },
        tooltipPlacement: "right" as TOOLTIP_PLACEMENT,
        tooltip: "Text",
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 6,
        modal: false,
        brearVisible: false,
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            You can also add an <strong>integration category</strong> of your favorite app and wearable. You'll see the metrics in your interface.
                            <br />
                            <br />
                            Now we support:
                            <ul style={{
                                paddingInlineStart: "15px",
                                marginBlockStart: "0px",
                                marginBlockEnd: "0px"
                            }}>
                                <li>
                                    Google Fit
                                </li>
                                <li>
                                    Whoop
                                </li>
                                <li>
                                    Oura
                                </li>
                                <li>
                                    RescueTime
                                </li>
                                <li>
                                    Garmin
                                </li>
                                <li>
                                    Toggl
                                </li>
                            </ul>
                        </>} />
                    </Box>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={"8px"}
                        alignSelf={"stretch"}
                        sx={{
                            '& > button': {
                                flex: 1
                            }
                        }}
                    >
                        <NewButton
                            buttonText="Back"
                            onClick={onBackButtonClick}
                            extraSx={{
                                padding: "16px",
                                height: "40px",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%",
                                background: "var(--color-border)",
                                "&:hover": {
                                    background: "var(--color-border)",
                                }
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `600 !important`
                            }}
                            padding="16px"
                            borderRadius="20px" />
                        <NewButton
                            buttonText="Next"
                            onClick={onButtonClick}
                            extraSx={{
                                padding: "16px",
                                height: "40px",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%"
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `600 !important`
                            }}
                            padding="16px"
                            borderRadius="20px" />
                    </Box>

                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            return ".default-col-1-row-1"

        },
        customInTable: (classes) => {
            const boxRetrn = (icon, title, gap = 4, typeShow = false) => {
                return <tr >
                    <td style={{
                        padding: "16px",
                        background: "#FFF",
                        borderBottom: "1px solid var(--color-border)"
                    }}><Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        gap={"16px"}
                    >
                            <Box display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                                gap={gap + "px"}>
                                {icon}
                                {title}
                            </Box>
                            {typeShow && (
                                <Box display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"space-between"}
                                    gap={"16px"}>
                                    <Box width="82px"
                                        height="18px"
                                        borderRadius="6px"
                                        gap="8px"
                                        border="2px solid var(--color-new-main)"
                                        padding="4px 8px"
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"center"}

                                    >
                                        <CommonTypo size={12} fontWeight={400} color="var(--color-text-primary)">Integration</CommonTypo>
                                    </Box>
                                    <Box width="24px"
                                        height="24px"
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"center"}>
                                        <ArrowDownNewBlack />
                                    </Box>
                                </Box>
                            )}

                        </Box>
                    </td>
                </tr>
            }
            return <Box
                sx={{
                    // background: "red",
                    width: "100%",
                    height: "100%"
                }}
                borderRadius="12px"
                padding="16px"
                display={"flex"}
                flexDirection={"column"}
            >
                <table width="100%" cellPadding={0} cellSpacing={0}>

                    {boxRetrn(<img
                        alt="toggl"
                        width="16px" height="16px"
                        src={"/oura.png"
                        }
                        style={{
                            height: "16px",
                            width: "16px",
                            borderRadius: "10px"
                        }}
                    />, <CommonTypo size={18} fontWeight={600} color="var(--color-text-primary)">Oura</CommonTypo>, 8, true)}


                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">😴</CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Sleep score</CommonTypo>, 4)}

                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">💤 </CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Sleep duration</CommonTypo>, 4)}

                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">🌡️ </CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Body temperatureq</CommonTypo>, 4)}

                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">🏃</CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Activity score</CommonTypo>, 4)}
                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">👣</CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Steps</CommonTypo>, 4)}
                </table>
            </Box>
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            return ".default-col-1-row-1"
        },
        tooltip: "Text",
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 7,
        modal: false,
        brearVisible: false,
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            Why wait? Let's connect an integration and import the data now!
                        </>} />
                    </Box>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={"8px"}
                        flexDirection={"column"}
                        alignSelf={"stretch"}
                    >

                        <NewButton
                            buttonText="Next"
                            onClick={onButtonClick}
                            extraSx={{
                                height: "40px",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%"
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `600 !important`
                            }}
                            padding="16px"
                            borderRadius="20px" />
                        <NewButton
                            buttonText="Back"
                            onClick={onBackButtonClick}
                            extraSx={{
                                height: "40px !important",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%",
                                background: "var(--color-border)",
                                "&:hover": {
                                    background: "var(--color-border)",
                                }
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `600 !important`
                            }}
                            padding="16px"
                            borderRadius="20px" />
                    </Box>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={"8px"}
                        flexDirection={"column"}
                        alignSelf={"stretch"}
                    >

                        <NewButton
                            buttonText="Skip"
                            variant="text"
                            onClick={onSkip}
                            extraSx={{
                                height: "19px",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%",
                                "&:hover": {
                                    background: "transparent"
                                }
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `400 !important`,
                                textDecoration: "underline"
                            }}
                            padding="0px"
                            borderRadius="20px" />

                    </Box>
                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            return ".default-col-1-row-1"

        },
        customInTable: (classes) => {
            const boxRetrn = (icon, title, gap = 4, typeShow = false) => {
                return <tr >
                    <td style={{
                        padding: "16px",
                        background: "#FFF",
                        borderBottom: "1px solid var(--color-border)"
                    }}><Box
                        display={"flex"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        gap={"16px"}
                    >
                            <Box display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-between"}
                                gap={gap + "px"}>
                                {icon}
                                {title}
                            </Box>
                            {typeShow && (
                                <Box display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"space-between"}
                                    gap={"16px"}>
                                    <Box width="82px"
                                        height="18px"
                                        borderRadius="6px"
                                        gap="8px"
                                        border="2px solid var(--color-new-main)"
                                        padding="4px 8px"
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"center"}

                                    >
                                        <CommonTypo size={12} fontWeight={400} color="var(--color-text-primary)">Integration</CommonTypo>
                                    </Box>
                                    <Box width="24px"
                                        height="24px"
                                        display={"flex"}
                                        alignItems={"center"}
                                        justifyContent={"center"}>
                                        <ArrowDownNewBlack />
                                    </Box>
                                </Box>
                            )}

                        </Box>
                    </td>
                </tr>
            }
            return <Box
                sx={{
                    // background: "red",
                    width: "100%",
                    height: "100%"
                }}
                borderRadius="12px"
                padding="16px"
                display={"flex"}
                flexDirection={"column"}
            >
                <table width="100%" cellPadding={0} cellSpacing={0}>

                    {boxRetrn(<img
                        alt="toggl"
                        width="16px" height="16px"
                        src={"/oura.png"
                        }
                        style={{
                            height: "16px",
                            width: "16px",
                            borderRadius: "10px"
                        }}
                    />, <CommonTypo size={18} fontWeight={600} color="var(--color-text-primary)">Oura</CommonTypo>, 8, true)}


                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">😴</CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Sleep score</CommonTypo>, 4)}

                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">💤 </CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Sleep duration</CommonTypo>, 4)}

                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">🌡️ </CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Body temperatureq</CommonTypo>, 4)}

                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">🏃</CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Activity score</CommonTypo>, 4)}
                    {boxRetrn(
                        <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">👣</CommonTypo>
                        , <CommonTypo size={16} fontWeight={400} color="var(--color-text-primary)">Steps</CommonTypo>, 4)}
                </table>
            </Box>
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            return ".default-col-1-row-1"
        },
        tooltip: "Text",
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 8,
        modal: true,
        brearVisible: false,
        content: (
            IUserTypeState: IUserTypeState,
            onButtonClick = () => { },
            onBackButtonClick = () => { },
            onSkip = () => { },
            setShowSnakbar?: React.Dispatch<React.SetStateAction<boolean>>,
            setSnakbarMsg?: React.Dispatch<React.SetStateAction<string>>,
            setMsgType?: React.Dispatch<React.SetStateAction<string>>,
            setPreventAutoHide?: React.Dispatch<React.SetStateAction<boolean>>,
            setmsgIcon?: React.Dispatch<React.SetStateAction<string>>,
            connectedIntegrations = []
        ) => {
            return <>
                <Box display={"flex"} alignItems={"center"} gap={"16px"} zIndex={1} sx={{
                    background: "transparent"
                }}>
                    <Box display={"flex"} flexDirection={"column"} borderRadius={"12px"} padding={"24px"} justifyContent={"space-between"} zIndex={1} sx={{
                        background: "#fff",
                        width: "350px",
                        height: "353px",
                        minWidth: "350px",
                        maxWidth: "350px",
                    }}>
                        <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
                            <ForastBearWithImage />
                            <TextBoxWithBorder text={connectedIntegrations && connectedIntegrations.length ? <>You've connected {connectedIntegrations.map(it => `"${it}"`).join(", ")}. Want to connect more or we are moving on?</> : <>
                                Which app would you like to connect?  When you are done connecting all the apps you need, click "Next"
                            </>} />
                        </Box>
                        <Box
                            display={"flex"}
                            alignItems={"center"}
                            gap={"8px"}
                            flexDirection={"column"}
                            alignSelf={"stretch"}
                        >

                            <NewButton
                                buttonText="Next"
                                onClick={onButtonClick}
                                extraSx={{
                                    height: "40px",
                                    borderRadius: "20px",
                                    zIndex: 1,
                                    width: "100%"
                                }}
                                boxSx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%"
                                }}
                                typographySx={{
                                    fontSize: "16px !important",
                                    color: "var(--color-text-primary)",
                                    fontWeight: `600 !important`
                                }}
                                padding="16px"
                                borderRadius="20px" />
                            <NewButton
                                buttonText="Back"
                                onClick={onBackButtonClick}
                                extraSx={{
                                    height: "40px !important",
                                    borderRadius: "20px",
                                    zIndex: 1,
                                    width: "100%",
                                    background: "var(--color-border)",
                                    "&:hover": {
                                        background: "var(--color-border)",
                                    }
                                }}
                                boxSx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%"
                                }}
                                typographySx={{
                                    fontSize: "16px !important",
                                    color: "var(--color-text-primary)",
                                    fontWeight: `600 !important`
                                }}
                                padding="16px"
                                borderRadius="20px" />
                        </Box>
                    </Box>
                    <Box zIndex={1} display={"flex"} alignItems={"center"} gap={"8px"} flexWrap={"wrap"} alignSelf={"stretch"} padding={"24px"} sx={{
                        background: "#fff",
                        width: "582px",
                        minWidth: "582px",
                        maxWidth: "582px",
                        height: "353px",
                    }} border={"1px solid var(--color-border)"} borderRadius={"12px"}>
                        <Integrations setShowSnakbar={setShowSnakbar} fromTutorials setSnakbarMsg={setSnakbarMsg} setMsgType={setMsgType} setPreventAutoHide={setPreventAutoHide} setmsgIcon={setmsgIcon} />
                    </Box>
                </Box >

            </>
        },
        dialogueStyles: {
            "& .MuiDialog-paper": {
                ...modalStyles,
                padding: "0px",
                width: "auto",
                height: "auto",
                boxShadow: "none",
                marginTop: "0px",
                margin: "auto",
                maxWidth: "max-content !important",
                background: "transparent"
            }
        } as SxProps<Theme>
    },
    // outcome type
    {
        step: 9,
        modal: false,
        brearVisible: false,
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            Try to track the metric to get used to it. <strong>Tap once</strong>  and enter a number from 1 to 5 using your keyboard.
                        </>} />
                    </Box>
                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    return `.default-col-5-row-${(foundGeneral + 1)}-subrow-1`
                }
            }

            return ".default-col-1-row-1"
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    return `.default-col-1-row-${(foundGeneral + 1)}`
                }
            }

            return ".default-col-1-row-1"
        },
        tooltipPlacement: "bottom" as TOOLTIP_PLACEMENT,
        tooltipTargetSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    return `.default-col-2-row-${(foundGeneral + 1)}-subrow-1`
                }
            }

            return null
        },
        tooltip: "Text",
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    // outcome add successfully
    {
        step: 10,
        skip: true,
        modal: false,
        brearVisible: true,
        bearFile: "/bearthumbup.png",
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    minWidth="350px"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearNormal />
                        <TextBoxWithBorder text={<>
                            Awesome! That was an outcome type of metric. Your key goals and metrics you want to track and improve. These are the main areas of focus in your journey - whether it's sleep quality, stress levels, or other important aspects of your life.
                        </>} />
                    </Box>
                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    return `.default-col-5-row-${(foundGeneral + 1)}-subrow-1`
                }
            }

            return ".default-col-1-row-1"
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    return `.default-col-1-row-${(foundGeneral + 1)}`
                }
            }

            return ".default-col-1-row-1"
        },
        tooltipPlacement: "right" as TOOLTIP_PLACEMENT,
        tooltip: "Text",
        clickable: true,
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    // influence type
    {
        step: 11,
        modal: false,
        brearVisible: false,
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    minWidth="350px"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            Awesome! Now, let's try to add another entry for influence metric. <br /><strong>Double tap.</strong>
                        </>} />
                    </Box>
                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    const foundInfluenceIndex = IUserTypeState.journeyCategoryList[foundGeneral]?.alls?.findIndex(it => it.influenceId)
                    if (foundInfluenceIndex > -1) {
                        return `.default-col-5-row-${(foundGeneral + 1)}-subrow-${(foundInfluenceIndex + 1)}`
                    }
                    return `.default-col-5-row-${(foundGeneral + 1)}-subrow-1`
                }
            }

            return ".default-col-1-row-1"
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                console.log("IUserTypeState.journeyCategoryList", IUserTypeState.journeyCategoryList);

                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {


                    if (foundGeneral > -1) {
                        return `.default-col-1-row-${(foundGeneral + 1)}`
                    }
                }
            }
            return ".default-col-1-row-1"
        },
        tooltipPlacement: "bottom" as TOOLTIP_PLACEMENT,
        tooltipTargetSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    const foundInfluenceIndex = IUserTypeState.journeyCategoryList[foundGeneral]?.alls?.findIndex(it => it.influenceId)
                    if (foundInfluenceIndex > -1) {
                        return `.default-col-2-row-${(foundGeneral + 1)}-subrow-${(foundInfluenceIndex + 1)}`
                    }
                    return `.default-col-2-row-${(foundGeneral + 1)}-subrow-1`
                }
            }

            return null
        },
        tooltip: "Text",
        clickable: false,
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 12,
        modal: false,
        brearVisible: false,
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    minWidth="350px"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            You've discovered another way to add entries...and comments!
                            <br />Comments are crucial to understand the "Why?" and "What" behind your entries.
                            <br /><br />Answer "why this score/value?
                        </>} />
                    </Box>
                </Box>

            </>
        },
        tooltipPlacement: "right" as TOOLTIP_PLACEMENT,
        tooltipTargetSelector: () => {
            // Select the last button in addHoursModal
            return ".MuiDialog-container .MuiPaper-root button.MuiButton-contained";
        },
        tooltip: "Text",
        clickable: false,
        fromTable: false,
        useCustomTooltip: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 13,
        modal: false,
        skip: true,
        brearVisible: true,
        bearFile: "/bearpointup.png",
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    minWidth="350px"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearNormal />
                        <TextBoxWithBorder text={<>
                            Good job! This time it was Influence. Actions, habits, or factors that may affect your outcomes. By tracking these, you'll discover which activities help you progress and which might be holding you back.
                        </>} />
                    </Box>
                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    const foundInfluenceIndex = IUserTypeState.journeyCategoryList[foundGeneral]?.alls?.findIndex(it => it.influenceId)
                    if (foundInfluenceIndex > -1) {
                        return `.default-col-5-row-${(foundGeneral + 1)}-subrow-${(foundInfluenceIndex + 1)}`
                    }
                    return `.default-col-5-row-${(foundGeneral + 1)}-subrow-1`
                }
            }
            return ".default-col-1-row-1"
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                console.log("IUserTypeState.journeyCategoryList", IUserTypeState.journeyCategoryList);

                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    if (foundGeneral > -1) {
                        return `.default-col-1-row-${(foundGeneral + 1)}`
                    }
                }
            }
            return ".default-col-1-row-1"
        },
        tooltipPlacement: "right" as TOOLTIP_PLACEMENT,
        tooltip: "Text",
        clickable: true,
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    // reflective type
    {
        step: 14,
        modal: false,
        brearVisible: false,
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    minWidth="350px"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            And for the last - answer <br />a qualitative question
                        </>} />
                    </Box>
                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    const foundInfluenceIndex = IUserTypeState.journeyCategoryList[foundGeneral]?.alls?.findIndex(it => it.reflectiveId)
                    if (foundInfluenceIndex > -1) {
                        return `.default-col-5-row-${(foundGeneral + 1)}-subrow-${(foundInfluenceIndex + 1)}`
                    }
                    return `.default-col-5-row-${(foundGeneral + 1)}-subrow-1`
                }
            }

            return ".default-col-1-row-1"
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                console.log("IUserTypeState.journeyCategoryList", IUserTypeState.journeyCategoryList);

                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {


                    if (foundGeneral > -1) {
                        return `.default-col-1-row-${(foundGeneral + 1)}`
                    }
                }
            }
            return ".default-col-1-row-1"
        },
        tooltipPlacement: "bottom" as TOOLTIP_PLACEMENT,
        tooltipTargetSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    const foundInfluenceIndex = IUserTypeState.journeyCategoryList[foundGeneral]?.alls?.findIndex(it => it.reflectiveId)
                    if (foundInfluenceIndex > -1) {
                        return `.default-col-2-row-${(foundGeneral + 1)}-subrow-${(foundInfluenceIndex + 1)}`
                    }
                    return `.default-col-2-row-${(foundGeneral + 1)}-subrow-1`
                }
            }

            return null
        },
        tooltip: "Text",
        clickable: false,
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 16,
        modal: false,
        skip: true,
        brearVisible: true,
        bearFile: "/bearhappyup.png",
        overlayVisible: true,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    minWidth="350px"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearNormal />
                        <TextBoxWithBorder text={<>
                            Nice! That was a reflective question. Open-ended reflections that help you capture the 'why' behind your numbers. These insights add context to your data and help uncover deeper patterns in your behavior.
                        </>} />
                    </Box>
                </Box>

            </>
        },
        columnSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    const foundInfluenceIndex = IUserTypeState.journeyCategoryList[foundGeneral]?.alls?.findIndex(it => it.reflectiveId)
                    if (foundInfluenceIndex > -1) {
                        return `.default-col-5-row-${(foundGeneral + 1)}-subrow-${(foundInfluenceIndex + 1)}`
                    }
                    return `.default-col-5-row-${(foundGeneral + 1)}-subrow-1`
                }
            }

            return ".default-col-1-row-1"
        },
        rowSelector: (IUserTypeState: IUserTypeState) => {
            if (IUserTypeState.journeyCategoryList && IUserTypeState.journeyCategoryList.length) {
                console.log("IUserTypeState.journeyCategoryList", IUserTypeState.journeyCategoryList);

                const foundGeneral = IUserTypeState.journeyCategoryList.findIndex(it => it.integrationType === "GENERAL")
                if (foundGeneral > -1) {
                    if (foundGeneral > -1) {
                        return `.default-col-1-row-${(foundGeneral + 1)}`
                    }
                }
            }
            return ".default-col-1-row-1"
        },
        tooltipPlacement: "right" as TOOLTIP_PLACEMENT,
        tooltip: "Text",
        clickable: true,
        fromTable: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 17,
        modal: false,
        brearVisible: false,
        overlayVisible: false,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            return <>
                <Box width="auto"
                    height="auto"
                    minWidth="350px"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            Turn the <strong>expand view</strong> if you want to
                            <ul style={{
                                paddingInlineStart: "25px",
                                marginBlockStart: "0px",
                                marginBlockEnd: "0px"
                            }}>
                                <li>
                                    see all comments to gain a juicy insight
                                </li>
                                <li>
                                    comment without opening the pop up
                                </li>
                            </ul>
                        </>} />
                    </Box>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={"8px"}
                        flexDirection={"column"}
                        alignSelf={"stretch"}
                    >

                        <NewButton
                            buttonText="Nice!"
                            onClick={onButtonClick}
                            extraSx={{
                                height: "40px",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%"
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `600 !important`
                            }}
                            padding="16px"
                            borderRadius="20px" />
                    </Box>
                </Box>

            </>
        },
        elementSelector: (IUserTypeState: IUserTypeState) => {
            return ".expand-view-controls"
        },
        tooltipPlacement: "bottom-start" as TOOLTIP_PLACEMENT,
        tooltip: "Text",
        clickable: false,
        fromElement: true,
        dialogueStyles: {
            "& .MuiDialog-paper": modalStyles
        } as SxProps<Theme>
    },
    {
        step: 18,
        islast: true,
        modal: false,
        brearVisible: false,
        overlayVisible: false,
        content: (IUserTypeState: IUserTypeState, onButtonClick, onBackButtonClick = () => { }, onSkip = () => { }) => {
            const { journeyCategoryList = [] } = IUserTypeState
            let planName = "Stress"
            if (journeyCategoryList && journeyCategoryList[0] && journeyCategoryList[0].name) {
                planName = journeyCategoryList[0].name
            }
            return <>
                <Box width="350px"
                    height="auto"
                    minWidth="350px"
                    borderRadius="12px"
                    padding="24px"
                    gap="16px"
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Box
                        gap="8px"
                        display={"flex"}
                        flexDirection={"column"}
                    >
                        <ForastBearWithImage />
                        <TextBoxWithBorder text={<>
                            Day 1 onboarding, done!
                        </>} />
                        <TextBoxWithBorder text={<>
                            Here's something that'll give you chills
                            <br />
                            <br />
                            TNT explorers who started the {planName} plan reported <strong>20% improvements in their {planName} outcomes</strong>  in just one month! 🤯
                        </>} />
                        <TextBoxWithBorder text={<>
                            Become a tenacious tracker! Track, analyze, improve - let's make yourself even cooler! 🐻‍❄️
                        </>} />
                    </Box>
                    <Box
                        display={"flex"}
                        alignItems={"center"}
                        gap={"8px"}
                        flexDirection={"column"}
                        alignSelf={"stretch"}
                    >

                        <NewButton
                            buttonText="Let’s go!"
                            onClick={onButtonClick}
                            extraSx={{
                                height: "40px",
                                borderRadius: "20px",
                                zIndex: 1,
                                width: "100%"
                            }}
                            boxSx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "100%"
                            }}
                            typographySx={{
                                fontSize: "16px !important",
                                color: "var(--color-text-primary)",
                                fontWeight: `600 !important`
                            }}
                            padding="16px"
                            borderRadius="20px" />
                    </Box>
                </Box>

            </>
        },
        elementSelector: (IUserTypeState: IUserTypeState) => {
            return ".expand-view-controls"
        },
        tooltipPlacement: "bottom-start" as TOOLTIP_PLACEMENT,
        tooltip: "Text",
        clickable: false,
        fromElement: true,
        dialogueStyles: {
            "& .MuiDialog-paper": {
                ...modalStyles,
                zIndex: 10000,
                padding: "0px",
                width: "auto",
                height: "auto",
                boxShadow: "none",
                marginTop: "0px",
                margin: "auto",
                maxWidth: "max-content !important",
            }
        } as SxProps<Theme>
    },
];
